import React, { memo, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Descriptions, Collapse, Spin, Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { EntityCommonInfoModel } from "../../entities/common";
import { DateTimeViewer } from "..";

export interface IndexPageHeaderProps {
  title: string;
  query: Function;
  queryArgs?: any;
  generalInfoPresentor?: (info: any) => JSX.Element | null;
  extra?: React.ReactNode;
  tabs?: { title: string; key: string; content: () => JSX.Element }[];
}

export const IndexPageHeader = memo(({ title, query, queryArgs, generalInfoPresentor, extra, tabs }: IndexPageHeaderProps) => {
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = query(queryArgs);

  const info: EntityCommonInfoModel = useMemo(
    () => ({
      totalRecords: data?.totalRecords ?? 0,
      lastCreateAt: data?.lastCreateAt ?? "",
      lastUpdateAt: data?.lastUpdateAt ?? "",
    }),
    [data]
  );

  const infoContent = useMemo(
    () => (
      <div>
        {generalInfoPresentor ? (
          generalInfoPresentor(data)
        ) : (
          <Descriptions
            size="small"
            column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
            title={<span className="text-sm text-gray-500">اطلاعات کلی</span>}>
            <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
              {info.totalRecords}
            </Descriptions.Item>
            <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
              <DateTimeViewer value={info.lastCreateAt} mode="distance" />
            </Descriptions.Item>
            <Descriptions.Item label="آخرین ویرایش" labelStyle={{ color: "gray" }}>
              <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
            </Descriptions.Item>
          </Descriptions>
        )}
      </div>
    ),
    [data, generalInfoPresentor, info]
  );

  return (
    <Collapse>
      <Collapse.Panel
        key="1"
        header={<span className="text-lg">{title}</span>}
        extra={
          extra === undefined
            ? [
                <Button
                  key="1"
                  type="primary"
                  onClick={() => navigate("new")}
                  icon={<FontAwesomeIcon className="anticon align-middle" icon={faPlus} />}>
                  جدید
                </Button>,
              ]
            : extra
        }>
        <Spin spinning={isLoading || isFetching}>
          {tabs ? (
            <Tabs defaultActiveKey="1" tabPosition="top">
              <Tabs.TabPane tab="اطلاعات کلی" key="info">
                {infoContent}
              </Tabs.TabPane>
              {tabs.map((tab) => (
                <Tabs.TabPane tab={tab.title} key={tab.key}>
                  {tab.content()}
                </Tabs.TabPane>
              ))}
            </Tabs>
          ) : (
            infoContent
          )}
        </Spin>
      </Collapse.Panel>
    </Collapse>
  );
});
